module.exports = __webpack_public_path__ + "media/images/icons/linkedin-f732c2b73d4ca6697177e8a5f7056172.svg";